import { useEffect, useRef, useState } from 'react';

import { useFormDataQuery } from '@/api/getters';
import { PRODUCT } from '@/consts';
import { useStepper } from '@/features/v2/lib/stepper';

import { FieldValues, useFormContext } from 'react-hook-form';

const useScrollToStep = () => {
  const ref = useRef<HTMLDivElement>(null);
  const { data } = useFormDataQuery();

  const methods = useFormContext();
  const values = methods.watch();

  const [clicked, setClicked] = useState(false);

  const prevValues = useRef<FieldValues>(values);

  const { innerStep, currentStep, step } = useStepper();

  const isUploader = !!currentStep?.subSteps;

  useEffect(() => {
    const addedFieldKeys = Object.keys(values).filter(
      (key) => !(key in prevValues.current)
    );

    const hasAddedFields = addedFieldKeys.length > 0;

    const isSurveyFourVD =
      data?.product.id !== PRODUCT.HOUSE_HOLD && step === 2 && innerStep === 2;

    const isSurveyTwoHH =
      (data?.product.id === PRODUCT.HOUSE_HOLD && step === 1) || step === 2;

    const isOfferForm = step === 5 || step === 6;

    // Transmission mounts every step at once (wizard.tsx's isTransmission
    // mode), so fields register progressively right after mount and trip
    // `hasAddedFields` before the user has touched anything. Ecommerce steps
    // already manage their own scroll-into-view via useScrollToNextField, so
    // this generic mechanism is redundant here and only causes an unwanted
    // jump on load.
    const isTransmission = data?.product.id === PRODUCT.TRANSMISSION;

    const bockScroll = isSurveyFourVD || isSurveyTwoHH || isTransmission;

    const initialLoad = Object.values(values).some((v) => v !== undefined);

    const OFFSET = 500;

    if (
      ref.current &&
      hasAddedFields &&
      initialLoad &&
      !isUploader &&
      !isOfferForm &&
      !bockScroll
    ) {
      const targetScroll = ref.current.offsetTop - OFFSET;
      if (targetScroll > 100) {
        setTimeout(() => {
          window.scrollTo({
            top: targetScroll,
            behavior: 'smooth',
          });
        }, 100);
      }
    }
    setClicked(false);

    prevValues.current = values;
  }, [innerStep, isUploader, values, step, methods, clicked, data?.product.id]);

  return {
    ref,
    setClicked,
  };
};

export default useScrollToStep;
